export class NavCartButton {

  constructor(element) {
    this.element = element;
    NavCartButton.element = this.element;
  }

  static activate() {
    NavCartButton.element.classList.remove('disabled');
  }

  static deactivate() {
    NavCartButton.element.classList.add('disabled');
  }
}

export const INSTANTIATE_NAV_CART_BUTTON = () => {

  const NAV_CART_BUTTON_ELEMENT = document.querySelector('[data-button="cart-show"]');
  if (!NAV_CART_BUTTON_ELEMENT) return;

  return new NavCartButton(NAV_CART_BUTTON_ELEMENT);
}
